;(() => {
  const namespace = (globalThis.StylistLocator = globalThis.StylistLocator || {})

  const VALID_RADII = [10, 125, 250, 375, 500]
  const VALID_CERTS = ['all', 'certified_salon', 'elite', 'masters', 'certified_stylist']
  const VALID_SORTS = ['best_match', 'nearest', 'highest_education']

  function snapToNearest(value, allowed) {
    let best = allowed[0]
    let bestDiff = Math.abs(value - best)
    for (let i = 1; i < allowed.length; i++) {
      const diff = Math.abs(value - allowed[i])
      if (diff < bestDiff) { best = allowed[i]; bestDiff = diff }
    }
    return best
  }

  function parseUrlParams() {
    const params = new URLSearchParams(window.location.search)
    if (!params.toString()) return null

    const result = {}

    if (params.has('q')) result.search = params.get('q')

    if (params.has('lat') && params.has('lng')) {
      const lat = parseFloat(params.get('lat'))
      const lng = parseFloat(params.get('lng'))
      if (!isNaN(lat) && !isNaN(lng) && lat >= -90 && lat <= 90 && lng >= -180 && lng <= 180) {
        result.searchCenter = { lat, lng }
      }
    }

    if (params.has('r')) {
      const r = Number(params.get('r'))
      if (!isNaN(r) && r > 0) result.radius = snapToNearest(r, VALID_RADII)
    }

    if (params.has('cert')) {
      const cert = params.get('cert')
      if (VALID_CERTS.includes(cert)) result.certification = cert
    }

    if (params.has('spec')) {
      const specs = params.get('spec').split(',').filter(Boolean)
      if (specs.length) result.activeSpecializations = specs
    }

    if (params.has('svc')) {
      const svcs = params.get('svc').split(',').filter(Boolean)
      if (svcs.length) result.activeServiceOptions = svcs
    }

    if (params.has('sort')) {
      const sort = params.get('sort')
      if (VALID_SORTS.includes(sort)) result.activeSort = sort
    }

    if (params.has('stylist')) result.selectedStylistId = params.get('stylist')
    if (params.has('form') && params.get('form') === '1') result.showRequest = true

    return Object.keys(result).length ? result : null
  }

  function buildUrlParams(state) {
    const params = new URLSearchParams()

    if (state.search) params.set('q', state.search)
    if (state.searchCenter) {
      params.set('lat', state.searchCenter.lat.toFixed(4))
      params.set('lng', state.searchCenter.lng.toFixed(4))
    }
    if (state.radius != null) params.set('r', String(state.radius))
    if (state.certification && state.certification !== 'all') params.set('cert', state.certification)
    if (state.activeSpecializations?.length) params.set('spec', state.activeSpecializations.join(','))
    if (state.activeServiceOptions?.length) params.set('svc', state.activeServiceOptions.join(','))
    if (state.activeSort && state.activeSort !== 'best_match') params.set('sort', state.activeSort)

    if (state.selectedStylist?.id) params.set('stylist', state.selectedStylist.id)
    if (state.showRequest) params.set('form', '1')

    return params.toString()
  }

  function updateUrl(state, usePushState) {
    const search = buildUrlParams(state)
    const url = search ? `${window.location.pathname}?${search}` : window.location.pathname
    if (usePushState) {
      history.pushState(null, '', url)
    } else {
      history.replaceState(null, '', url)
    }
  }

  namespace.url = { parseUrlParams, buildUrlParams, updateUrl }
})()
